export const LEGACY_CREDENTIAL_NAMES = [
  'lytics',
  'lytics-audiences',
] as const;

const legacyCredentialNames = new Set<string>(LEGACY_CREDENTIAL_NAMES);

interface CredentialWithName {
  name: string;
  active: boolean;
}

interface CredentialTypeOption {
  value?: unknown;
}

export const isLegacyCredentialName = (name: unknown): boolean =>
  typeof name === 'string' && legacyCredentialNames.has(name);

export const filterVisibleCredentials = <T extends CredentialWithName>(
  credentials: readonly T[] | null | undefined
): T[] =>
  (credentials || []).filter(
    (credential) => !isLegacyCredentialName(credential.name)
  );

export const omitLegacyCredentialTypes = <T>(
  credentialTypes: Record<string, T> | null | undefined
): Record<string, T> => {
  if (!credentialTypes) {
    return {};
  }

  return Object.entries(credentialTypes).reduce<Record<string, T>>(
    (visibleCredentialTypes, [key, option]) => {
      const optionValue = (option as CredentialTypeOption | null)?.value;

      if (
        !isLegacyCredentialName(key) &&
        !isLegacyCredentialName(optionValue)
      ) {
        visibleCredentialTypes[key] = option;
      }

      return visibleCredentialTypes;
    },
    {}
  );
};
